import { ClientPublicService } from '../../app/api/ClientPublicService';
import { IContactStaff } from './types';

export const convertFormValuesToDto = (data?: IContactStaff) =>
  ({
    teamId: data?.teamId || undefined,
    message: data?.message || undefined,
    subject: data?.subject || undefined,
  } as ClientPublicService.IContactStaffDto);
